import { LuAlertTriangle } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";

const NotFoundPage = () => {
  const navigate = useNavigate();
  return (
    <div className="tw-min-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-background-100 tw-px-6">
      <div
        className="tw-flex tw-items-center tw-justify-center tw-w-20 tw-h-20 tw-rounded-3xl tw-mb-6"
        style={{ background: "linear-gradient(135deg, #052e16, #166534)" }}
      >
        <span className="tw-text-white tw-text-3xl tw-font-black">M</span>
      </div>

      <LuAlertTriangle className="tw-text-red-400 tw-text-6xl tw-mb-4" />

      <div className="tw-font-black tw-text-7xl tw-text-text-primary tw-mb-2">
        404
      </div>
      <div className="tw-text-lg tw-font-semibold tw-text-text-primary tw-mb-2">
        Halaman tidak ditemukan
      </div>
      <div
        className="tw-text-sm tw-text-text-secondary tw-text-center tw-mb-8"
        style={{ maxWidth: "280px", lineHeight: "1.6" }}
      >
        Halaman yang kamu cari tidak bisa ditemukan. Kembali ke Beranda?
      </div>

      <Button
        className="tw-h-11 tw-px-8 tw-text-sm tw-font-semibold tw-rounded-xl tw-border-0 tw-text-white focus:tw-shadow-none"
        style={{ background: "#166534" }}
        htmlType="button"
        onClick={() => navigate("/")}
      >
        Kembali ke Beranda
      </Button>
    </div>
  );
};

export default NotFoundPage;
